import {ISelectItem} from '~/components/Controls/Select/common';

export const defaultNumericSort = <T>(a: ISelectItem<T>, b: ISelectItem<T>): number => {
    if (typeof a.value === 'number' && typeof b.value === 'number') {
        return a.value - b.value;
    }
    return 0;
};
